import {env, memoize} from 'core/decorators/index';
import {ScriptConnectionError} from 'core/exceptions/ScriptConnectionError';

export interface IScriptConnection {
    element: HTMLScriptElement;
    event?: Event | ErrorEvent;
}

export const connectScript = memoize(
    env(
        'client',
        function connectScript(url: string, id: string, mountingPoint?: HTMLElement): Promise<IScriptConnection> {
            return new Promise<IScriptConnection>((resolve, reject) => {
                const prevScript = document.querySelector<HTMLScriptElement>(`#${id}`);
                if (prevScript) {
                    resolve({element: prevScript});
                    return;
                }

                const point = mountingPoint ?? document.head;
                const scriptElement = document.createElement('script');

                scriptElement.id = id;
                scriptElement.async = true;
                scriptElement.src = url;
                scriptElement.type = 'text/javascript';

                scriptElement.addEventListener('load', (event) => {
                    resolve({element: scriptElement, event});
                });

                scriptElement.addEventListener('error', () => {
                    reject(new ScriptConnectionError(url));
                });

                point.append(scriptElement);
            });
        },
    ),
);
